var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-20"},[_c('Aboutpage'),_c('Playlistnos'),_c('Letterform')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }